<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2"  variant="primary" @click="gpath_careerAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col>
              <!-- GPath Producat Id -->
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.pdt_id" class="form-control" title="session states" @change="setPdtId">
                  <option value="">Select Product Id</option>
                  <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id" >
                    {{ item.id }}
                  </option>
                </select>
              </b-col><!-- GPath Producat Id -->
            </b-row>
          </b-col>
          <b-col v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3">
            <CsvDownload :propModuleFile="cvModuleFile" class="Download_button" />
            <CsvUpload :propModulePrefix="cvModulePrefix" class="Download_button"  />
            <VueJsonToCsv :json-data="gpath_careerObjList" csv-title="gpath_careers" v-if="gpath_careerObjList && gpath_careerObjList.length">
              <i class="fa-solid fa-file-csv Download_button"></i>
            </VueJsonToCsv>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="gpath_careerObjList && gpath_careerObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpath_careerObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage">
            <template v-slot:cell(image)="data">
                <img :src="data.item.image" style="background-color: #e52e2c; width: 50px; height: 50px;">
              </template>
              <template v-slot:cell(name)="data">
                <p>{{data.item.name}}</p>
                <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" title="Edit Career Name" @click="gpath_careerEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0"></i></b-button>
                <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" title="View GPaths Career Type" @click="gpath_career_list(data.item)"><i class="fa-solid fa-graduation-cap" aria-hidden="true"></i></b-button>
                <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" title="View GPaths Universities" @click="gpath_career_univ()"><i class="fa fa-university" aria-hidden="true"></i></b-button>
                <b-button variant="iq-bg-danger actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showGPathCareerDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
              </template>
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="7" md="8" class="my-1">
            <b-btn v-if="showLoadMoreBtn" variant="primary" @click="loadMoreData">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelGPathCareerAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xl">
      <GPathCareerAdd :propOpenedInModal="true" @emitCloseGPathCareerAddModal="closeGPathCareerAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_careerAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelGPathCareerEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xl">
      <GPathCareerEdit :propOpenedInModal="true" :propGPathCareerObj="gpath_careerEditObj" @emitCloseGPathCareerEditModal="closeGPathCareerEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_careerEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareerEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelGPathCareerDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelGPathCareerDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_careerDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { GPathCareers } from "../../../FackApi/api/GPathCareer"
import GPathCareerAdd from "./GPathCareerAdd"
import GPathCareerEdit from "./GPathCareerEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"

export default {
  name: "GPathCareerList",
  components: {
    GPathCareerAdd,
    GPathCareerEdit,
    CsvDownload,
    CsvUpload
  },
  data () {
    return {
      cvModuleFile: "gpath_careers",
      cvModulePrefix: "GPC",
      apiName: "gpath_careers_list",
      cvCardTitle: "GPaths Career Configuration",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit GPaths Career",
      cvAddModalHeader: "Add GPaths Career",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPathCareer List Response",
      showModelGPathCareerAdd: false,
      showModelGPathCareerEdit: false,
      showModelGPathCareerDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "image", key: "image", class: "", sortable: true },
        { label: "Product Id", key: "pdt_id", class: "text-left align-text-top text-break w-200px", sortable: true },
        { label: "name", key: "name", class: "text-left align-text-top", sortable: true },
        { label: "description", key: "description", class: "text-left align-text-top w-300px", sortable: true }
      ],
      gpath_careerObjList: null,
      gpath_careerEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentBatchNo: 1,
      dataPerPage: 5,
      delObj: null,
      showLoadMoreBtn: false,
      whereFilter: {
        isAdminPanel: true,
        pdt_id: "APPGPATHPRODUCTID"
      },
      gpcPdtIdList: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.gpath_careerList()
    this.gpathsproductIdListGet()
  },
  methods: {
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo++
      this.gpath_careerList(true)
    },
    /**
     * Calling SetPdtId into filter
    */
    async setPdtId () {
      this.currentBatchNo = 1
      this.gpath_careerList()
    },
    /**
     * gpath_careerList
     */
    async gpath_careerList (loadViaLoadMore = false) {
      this.showLoadMoreBtn = true
      try {
        let filter = {
          currentBatchNo: this.currentBatchNo,
          dataPerPage: this.dataPerPage,
          ...this.whereFilter
        }

        let gpathCareerListResp = await GPathCareers.gpath_careerList(this, filter)
        if (gpathCareerListResp.resp_status) {
          const gpathCareerList = gpathCareerListResp.resp_data.data || []

          if (loadViaLoadMore && this.gpath_careerObjList) {
            this.gpath_careerObjList = [...this.gpath_careerObjList, ...gpathCareerList]
          }
          else {
            this.gpath_careerObjList = gpathCareerList
          }

          this.gpath_careerObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.gpath_careerObjList.length
          this.currentBatchNo = this.totalRows / this.dataPerPage
          this.showLoadMoreBtn = gpathCareerList.length >= this.dataPerPage
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : this.currentBatchNo - 1
          this.showLoadMoreBtn = false
          this.toastMsg = gpathCareerListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_careerList() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_list
     */
    gpath_career_list (typeName) {
      this.$router.push(`/gpath_career_type_list/${typeName.name}`)
    },
    /**
     * gpath_career_univ
     */
    gpath_career_univ () {
      this.$router.push("/gpath_career_univ_list")
    },
    /**
     * gpath_careerAdd
     */
    gpath_careerAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_add")
        }
        else {
          this.showModelGPathCareerAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_careerAdd() and Exception:", err.message)
      }
    },
    /**
     * gpath_careerEdit
     */
    gpath_careerEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_edit/" + this.gpath_careerEditObj.gpc_id)
        }
        else {
          this.gpath_careerEditObj = item
          this.showModelGPathCareerEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_careerEdit() and Exception:", err.message)
      }
    },
    /**
     * showGPathCareerDeleteDialog
     */
    showGPathCareerDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathCareerDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathCareerDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_careerDelete
     */
    async gpath_careerDelete () {
      try {
        let gpathCareerDelResp = await GPathCareers.gpath_careerDelete(this, this.delObj.gpc_id)
        await ApiResponse.responseMessageDisplay(this, gpathCareerDelResp)

        if (gpathCareerDelResp && !gpathCareerDelResp) {
          this.showModelGPathCareerDelete = false
          return false
        }

        let index = this.gpath_careerObjList.indexOf(this.delObj)
        this.gpath_careerObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelGPathCareerDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_careerDelete() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerAddModal
     */
    closeGPathCareerAddModal (gpathCareerAddData) {
      try {
        if (gpathCareerAddData) {
          if (this.gpath_careerObjList && this.gpath_careerObjList.length >= 1) {
            let gpathCareerObjLength = this.gpath_careerObjList.length
            let lastId = this.gpath_careerObjList[gpathCareerObjLength - 1]["id"]
            gpathCareerAddData.id = lastId + 1
          }
          else {
            this.gpath_careerObjList = []
            gpathCareerAddData.id = 11111
          }

          gpathCareerAddData.created_on = moment()
          this.gpath_careerObjList.unshift(gpathCareerAddData)
          this.totalRows = this.totalRows + 1
        }

        this.showModelGPathCareerAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_careerAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareerEditModal
     */
    closeGPathCareerEditModal () {
      try {
        this.showModelGPathCareerEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeGPathCareerEditModal() and Exception:", err.message)
      }
    },
    /**
     * gpaths product Id List Get
    */
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    }
  }
}
</script>
